// --- INFO: data source - streetData.json
export enum NextSweepScheduleEnum {
  empty = "",
  oneToTwoWeeks = "1-2 weeks",
  fiveToSixWeeks = "5-6 weeks",
}

export interface StreetSweepingSchedule {
  readonly streetName: string;
  readonly suburb: string;
  readonly postcode: string;
  readonly nextSweepSchedule: string;
}

// --- INFO: data source - cb-city graphQL
export interface StreetSweeperGpsEvent {
  readonly unit_name?: string;
  readonly gps_time: string;
  readonly gps_lat: number;
  readonly gps_lon: number;
}

export interface GoogleMapCoordinate {
  lat: number | null;
  lng: number | null;
}

export interface SweeperTruckGpsData extends GoogleMapCoordinate {
  epochTime: number;
}

export interface MapAnimationPathCoordinate extends GoogleMapCoordinate {
  epochTime: number;
  distanceInMeter: number;
  timeInSec: number;
  velocity: number;
}
